var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.errorText.length > 0)?_c('div',{staticClass:"[ c-status-error ]"},[_c('svg',{staticClass:"[ o-icon ] [ c-status-error__icon ]"},[_c('use',{attrs:{"xlink:href":"/img/icons.svg?v=fc89cbad7b#icon-warning"}})]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorText)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }